<template>
  <div v-if="!loading">
    <div class="card-body card-body--cta">
      <a :href="`dashboard/consultations?consultationStatus[]=incomplete`" class="card-info--cta">
        <i class="fa fa-search"></i> View Incomplete Consultations
      </a>
    </div>

    <div class="card">
      <header class="card-header">
        <span class="card-header--title">Patient Consultations</span>
      </header>

      <div class="pagination-controls" v-if="pagination && pagination.totalPages > 1">
        <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1"
                class="button button-secondary--small">Prev
        </button>
        <span>Page {{ currentPage }} of {{ pagination.totalPages }}</span>
        <button @click="changePage(currentPage + 1)" :disabled="currentPage === pagination.totalPages"
                class="button button-secondary--small">Next
        </button>
      </div>

      <div class="card-body" v-for="consultation in consultations" :key="consultation.id">
        <div class="card--two-columns items-center">
          <div class="card-column card-column--vertical">
            <span class="card-body--subtitle-dark">{{ consultation.dateCreated }}</span>
            <span class="card-body--title card-body--title-dark">{{ getConsultationTitle(consultation) }}</span>
            <div class="card-body--label">
              <strong>Patient:</strong>
              <span>{{ consultation.firstName }} {{ consultation.lastName }}</span>
            </div>
            <div :class="`card-body--label-${consultation.status}`">{{ consultation.status }}</div>
          </div>
          <div class="card-column">
            <div class="card-action">
              <a
                :href="canSeeAllConsultations === 'true' ? '/dashboard/consultations/' + consultation.id : consultation.review"
                class="button button-primary--small button-block">
                Review Consult
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-if="consultations.length < 1" class="card-body card-body--messages">
        You do not currently have any new consultations to review.
      </div>

      <div class="pagination-controls" v-if="pagination && pagination.totalPages > 1">
        <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1"
                class="button button-secondary--small">Prev
        </button>
        <span>Page {{ currentPage }} of {{ pagination.totalPages }}</span>
        <button @click="changePage(currentPage + 1)" :disabled="currentPage === pagination.totalPages"
                class="button button-secondary--small">Next
        </button>
      </div>
    </div>
  </div>

  <div v-else class="lds-grid">
    <div class="lds-ripple">
      <div></div>
      <div></div>
    </div>
    <p>Loading incomplete consultations</p>
  </div>
</template>

<script>
import axios from 'axios';
import { EventBus } from './event-bus';

export default {
  name: 'v-patient-consultations',
  props: ['canSeeAllConsultations'],
  data() {
    return {
      consultations: [],
      pagination: null,
      currentPage: 1,
      loading: true,
      selectedCategory: '',
    };
  },
  mounted() {
    EventBus.$on('product-category-selected', category => {
      this.selectedCategory = category;
      this.currentPage = 1;
      this.consultations = [];
      this.loadConsultations();
    });
    this.loadConsultations();
  },
  methods: {
    getConsultationTitle(consultation) {
      return consultation.title;
    },
    loadConsultations(page = this.currentPage) {
      this.loading = true;
      const url = this.canSeeAllConsultations === 'true'
        ? '/dashboard/findSubmittedAndUnclosed'
        : '/dashboard/findSubmittedAndUnclosedForProvider';

      axios.post(url, { page, category: this.selectedCategory })
        .then(response => {
          this.consultations = response.data.data;
          this.pagination = response.data.pagination;
          this.currentPage = page;
        })
        .finally(() => this.loading = false);
    },
    changePage(page) {
      if (!this.pagination || page < 1 || page > this.pagination.totalPages) return;
      this.loadConsultations(page);
    },
  },
};
</script>


<style scoped lang="css">

.lds-grid {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  justify-content: center;
}

.lds-ripple,
.lds-ripple div {
  box-sizing: border-box;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #243153;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 80px;
    height: 80px;
    opacity: 0;
  }
}

.lds-grid p {
  color: #243153;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  gap: 10px;
}

.pagination-controls span {
  font-weight: bold;
}

</style>


// WEBPACK FOOTER //
// resources/assets/js/PatientConsultations.vue